var TabsControll = function(){

    'use strict';

    var $ = jQuery;    var instances = [];


    function onReady() {
        $('.module.tabs-controll').each(function () {
            instances.push(initInstance($(this)));
        });
    }

    function initInstance(view) {

        // Private properties
        // * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

        var $view = view,
            id = $view.data('id'),
            index = 0,
            items = [],
            itemsSizes = [],
            range = null,
            ids = [],
            platform = null;

        // Private methods
        // * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

        function startControlled() {
            // console.log('TabBox::startControlled: ');
            // items[0].removeClass('hidden');

        }


        function onItemInitiated($item) {

            var id = getItemId($item);
            items[id] = $item;
            itemsSizes[ids[index]] = $item.height();
            index++;
            console.log('itemsSizes: ', itemsSizes);
            // $item.attr('class').match(/(controlled){1}(-\w+\b){1}\W/)[0]
            // console.log('TabBox::onItemInitiated: ', ids.length, items.length);
            if (ids.length === items.length) {
                startControlled();
            }
        }

        function configurateRange() {
            range = $view.attr('class').match(/(controller){1}(-\w+\b){1,2}/)[0];
            $('.controlled.' + range).each(function () {
                ids.push(getItemId($(this)));
            });
        }

        function getItemId($item) {
            var id = $item.attr('class').match(/(controlled){1}(-\w+\b){1}\W/)[0];
            id = id.replace(/\ /, '');

            return id;
        }

        function mediaQueryChange(value) {
            platform = value;
        }

        function getChildrensHeight(item) {
            var max = 0;

            item.children().each(function () {
                max += $(this).height();
            });

            // console.log('MAX: ', max);

            return max;
        }

        // Public methods
        // * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

        // instance object

        var instance = {
            init: function () {

                // Subscribe events
                Events.subscribe('GENERAL_MEDIAQUERY_CHANGE', mediaQueryChange);

                // Trigger events
                Events.publish('GENERAL_MEDIAQUERY_CHECK', [mediaQueryChange]);

                // Remove this lines this and the next line
                // console.log('Instance of tabs-controll initialized with id and view: ', id, view);
                $view.find('.box').on('click', function (e) {
                    
                   

                    e.preventDefault();
                    $view.find('.active').removeClass('active');
                    $(this).addClass('active');

                    // console.log('CLICKED: ', $('.controlled-' + $(this).attr('data-related-tab')).hasClass('hidden') );
                    // console.log('CLICKED: ', $('section[class*="controlled-"]:not(.hidden)') );

                    var $target = $('.controlled-' + $(this).attr('data-related-tab'));
                    var $current = $('section[class*="controlled-"]:not(.hidden)');
                    var idCurrent = getItemId($current);
                    var idTarget = getItemId($target);

                    if ($('body').hasClass('t-mobile') === false) {
                        $('html, body').animate({
                            scrollTop: $current.offset().top - $('#menu').height()
                        }, 1000);                        
                    }

                    if ( $target.hasClass('hidden') ) {
                        $current.animate({
                            height: 0
                        }, 500, function () {
                            $current.addClass('hidden');
                            $target.height(0).removeClass('hidden')
                                .animate({
                                    height: (function () {
                                        if (platform === 'desktop') {
                                            return itemsSizes[idTarget];

                                        }
                                        else {
                                            return $target.find('.module-tabs-box-container').height();
                                        }
                                    })()
                                }, 500, function () {
                                    
                                    // Trigger events
                                    Events.publish('TAB_CONTROLL_ITEM_INIT', [idTarget, platform]);

                                    if (platform !== 'desktop') {
                                        $target.css('height', 'auto');
                                    }
                                });
                        });
                    }
                });

                configurateRange();
                Events.subscribe('TAB_CONTROLL_ITEM_INITIATED', onItemInitiated);
                Events.publish('TAB_BOX_INIT');
                
            }
        };

        

        instance.init();
        return instance;
    }

    // DOMContentLoaded
    $(onReady);

}

TabsControll();
